module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraBoldItalic.09a2d25.ttf";